module.exports = __webpack_public_path__ + "static/enterprise-3-m-31ef550200e4cc3b5c576035cb7db83a.png";